module.exports = __webpack_public_path__ + "BG.svg?67d1f5c286fc42f427057a5385734f1e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/symbols/BG.svg
// module id = 53
// module chunks = 0